import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import cn from 'classnames/bind';

// Components
import Page from 'components/Page';
import OurPartners from 'components/OurPartners';

// Styles
import styles from './styles.styl';

const cx = cn.bind(styles);

function AuthorPartners({ slug }) {
  const partners = useSelector(state => state.author.pages[slug].partners);

  return !partners ? null : (
    <Page.Section className={cx('AuthorPartners')} title={partners.title || 'Our Partners'}>
      <OurPartners {...partners} />
    </Page.Section>
  );
}

AuthorPartners.propTypes = {
  slug: PropTypes.string,
};

export default AuthorPartners;
